import { put, select } from "redux-saga/effects";

import { WidgetTypes } from "legacy/constants/WidgetConstants";
import { getWidget } from "legacy/selectors/entitiesSelector";
import { getWidgetIdFromName } from "legacy/selectors/sagaSelectors";

import { selectAiState } from "../selectors";
import { setPropertiesToChange, setNoResultsResponse } from "../slice";
import type { processAiProperties } from "../slice";

const REPLACEMENTS = {
  table_column: "primaryColumns",
  menu_item: "manualChildren",
  key_value_property: "properties",
};

export function* processAiPropertiesSaga(
  action: ReturnType<typeof processAiProperties>,
) {
  const payload = action.payload;
  const { originalNamesById } = yield select(selectAiState);

  if ("noResultsResponse" in payload && payload.noResultsResponse) {
    yield put(setNoResultsResponse(payload.noResultsResponse));
  }
  const { componentName, properties } = payload as {
    componentName: string;
    properties: string[];
  };
  let widgetId: string | undefined;
  if (Object.values(originalNamesById ?? {}).includes(componentName)) {
    widgetId = Object.keys(originalNamesById ?? {}).find(
      (key) => originalNamesById[key] === componentName,
    );
  } else {
    widgetId = yield select(getWidgetIdFromName, componentName);
  }
  if (!widgetId) {
    return;
  }
  const widget: ReturnType<typeof getWidget> = yield select(
    getWidget,
    widgetId,
  );
  const widgetType = widget?.type;
  const processedProperties: string[] = [];
  properties.forEach((property: string) => {
    if (
      widgetType === WidgetTypes.BUTTON_WIDGET &&
      property.includes("textColor")
    ) {
      processedProperties.push("textColor");
    } else if (property.startsWith("eventListener")) {
      // get the second piece of the property
      processedProperties.push(property.split(".")[1]);
    }
    const firstPart = property.split(".")[0];
    if (firstPart in REPLACEMENTS) {
      processedProperties.push(
        REPLACEMENTS[firstPart as keyof typeof REPLACEMENTS],
      );
      processedProperties.push(
        property.replace(
          firstPart,
          REPLACEMENTS[firstPart as keyof typeof REPLACEMENTS],
        ),
      );
    } else {
      processedProperties.push(property);
    }
  });

  yield put(
    setPropertiesToChange({ widgetId, properties: processedProperties }),
  );
}
